import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  plugins: {
    legend: { display: false },
    title: {
      display: false,
    },
  },
  scales: {
    xAxes: [
      {
        maxBarThickness: 20,
      },
    ],
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      grid: {
        borderDash: [4],
      },
    },
  },
};
// ["Not started", "New", "In progress", "Accepted", "Popular"];
const labels = ["", "", "", "", ""];
export default function GroupedBarChart(props) {
  const data = {
    labels,
    datasets: [
      {
        label: "Vacancies",
        data: labels.map((Item, i) => props.Data.jobs[i]),
        backgroundColor: "#6DA2F2",
        borderRadius: 4,
        marginLeft: 10,
        barThickness: 12,
      },
      {
        label: "Projects",
        data: labels.map((Item, i) => props.Data.projects[i]),
        backgroundColor: "#FFA8A8",
        borderRadius: 4,
        barThickness: 12,
      },
      {
        label: "Activities",
        data: labels.map((Item, i) => props.Data.activities[i]),
        backgroundColor: "#C7A3FF",
        borderRadius: 4,
        barThickness: 12,
      },
    ],
  };

  return (
    <Bar
      options={options}
      data={data}
      style={{ maxWidth: "760px", maxHeight: "240px" }}
    />
  );
}
